import { ENV_CONFIG } from './environment';

export interface FeatureFlags {
  debugMode: boolean;
  // Add other feature flags here as needed
  // example: enableNewUI: boolean;
  // example: enableBetaFeatures: boolean;
}

// Default feature flags configuration
export const defaultFeatureFlags: FeatureFlags = {
  debugMode: ENV_CONFIG.DEBUG_MODE, // Use environment configuration
};

// Environment-based feature flags
export const getFeatureFlags = (): FeatureFlags => {
  return {
    ...defaultFeatureFlags,
    debugMode: ENV_CONFIG.DEBUG_MODE,
  };
};

// Feature flag hooks and utilities
export const useFeatureFlag = (flag: keyof FeatureFlags): boolean => {
  const flags = getFeatureFlags();
  return flags[flag];
};

export const isDebugMode = (): boolean => {
  return getFeatureFlags().debugMode;
};
